// extracted by mini-css-extract-plugin
module.exports = {"item":"index-module--item--317lX","link":"index-module--link--3yzk1"};